<template>
  <div>
    <sidenav
      :is-sidebar-active.sync="sidebar"
      :is-add="isAdd"
      :item-edit="selected"
      :tenant-options="tenantOptions"
      @saved="refresh"
    />
    <b-row class="pt-2 pb-1"
      ><b-col><BreadcrumbMenu /></b-col
    ></b-row>
    <b-card class="mx-2 mt-1" no-body>
      <div class="m-2">
        <b-row
          ><b-col md="6" class="d-flex align-items-center"
            ><label>{{ $t("table.show") }}</label>
            <v-select
              v-model="perPage"
              :options="[10, 25, 50, 100]"
              :clearable="false"
              class="per-page-selector mx-50"
            /><label>{{ $t("table.entries") }}</label></b-col
          >
          <b-col md="6" class="d-flex justify-content-end"
            ><b-form-input
              v-model="search"
              :placeholder="$t('table.search')"
              class="mr-1"
            />
            <b-button
              v-if="$can('create', 'HanwhaAlarmProfile')"
              variant="primary"
              @click="openAdd"
              >{{
                `${$t("actions.add")} ${$tc("hanwha_alarm_profile.title", 1)}`
              }}</b-button
            ></b-col
          ></b-row
        >
      </div>
      <b-table
        ref="table"
        :items="fetchItems"
        :fields="fields"
        responsive
        show-empty
        :empty-text="$t('no_record_found')"
      >
        <template #head()="data">{{ $tc(data.label, 1) }}</template>
        <template #cell(enabled)="data"
          ><b-badge :variant="data.value ? 'success' : 'secondary'">{{
            data.value ? $t("yes") : $t("no")
          }}</b-badge></template
        >
        <template #cell(actions)="data"
          ><b-dropdown variant="link" no-caret
            ><template #button-content><feather-icon icon="MoreVerticalIcon" /></template>
            <b-dropdown-item
              v-if="$can('read', 'HanwhaAlarmRule')"
              @click="openRules(data.item)"
              ><feather-icon icon="ListIcon" />
              {{ $t("hanwha_alarm_profile.rules") }}</b-dropdown-item
            >
            <b-dropdown-item
              v-if="$can('update', 'HanwhaAlarmProfile')"
              @click="openEdit(data.item)"
              ><feather-icon icon="EditIcon" /> {{ $t("actions.edit") }}</b-dropdown-item
            >
            <b-dropdown-item
              v-if="$can('delete', 'HanwhaAlarmProfile')"
              @click="remove(data.item)"
              ><feather-icon icon="TrashIcon" />
              {{ $t("actions.delete") }}</b-dropdown-item
            >
          </b-dropdown></template
        >
      </b-table>
      <div class="mx-2 mb-2">
        <Pagination
          :total-list="total"
          :current-page="page"
          :per-page="perPage"
          @updatePagination="page = $event"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BTable,
  BButton,
  BFormInput,
  BDropdown,
  BDropdownItem,
  BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { debounce } from "lodash";
import store from "@/store";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import Pagination from "@/components/Pagination.vue";
import Sidenav from "./Sidenav.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BButton,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BBadge,
    vSelect,
    BreadcrumbMenu,
    Pagination,
    Sidenav,
  },
  data() {
    return {
      sidebar: false,
      isAdd: true,
      selected: {},
      perPage: 10,
      page: 1,
      total: 0,
      search: "",
      fields: [
        { key: "actions", label: "actions.name" },
        { key: "name", label: "hanwha_alarm_profile.name" },
        { key: "tenant.name", label: "tenants.title" },
        { key: "description", label: "hanwha_alarm_profile.description" },
        { key: "rules.length", label: "hanwha_alarm_profile.rules" },
        { key: "dvrs_count", label: "hanwha_alarm_profile.dvrs" },
        { key: "enabled", label: "hanwha_alarm_profile.enabled" },
      ],
    };
  },
  computed: {
    tenantOptions() {
      return store.getters["tenant/getSelectedItems"];
    },
  },
  watch: {
    page() {
      this.refresh();
    },
    perPage() {
      this.page = 1;
      this.refresh();
    },
    search: debounce(function () {
      this.page = 1;
      this.refresh();
    }, 400),
  },
  created() {
    store.dispatch("tenant/getAll", { max: 1000 });
  },
  methods: {
    fetchItems(ctx, done) {
      store
        .dispatch("hanwha_alarm_profiles/getAll", {
          max: this.perPage,
          "page[n]": this.page,
          q: this.search,
        })
        .then((r) => {
          this.total = r.meta.total;
          done(r.data);
        })
        .catch(() => done([]));
    },
    refresh() {
      this.$refs.table?.refresh();
    },
    openAdd() {
      this.isAdd = true;
      this.selected = {};
      this.sidebar = true;
    },
    openEdit(item) {
      this.isAdd = false;
      this.selected = { ...item };
      this.sidebar = true;
    },
    openRules(item) {
      this.$router.push({
        name: "hanwha_alarm_rules",
        params: { profileId: item.id },
        query: { profileName: item.name },
      });
    },
    remove(item) {
      this.$swal({
        title: this.$t("messages.delete.title"),
        text: this.$t("messages.delete.body"),
        icon: "warning",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await store.dispatch("hanwha_alarm_profiles/delete", item.id);
          this.refresh();
        }
      });
    },
  },
};
</script>
